import SessionExpiredModal from './SessionExpiredModal.vue';

export default SessionExpiredModal;
